import {
  CSSProperties,
  ChangeEventHandler,
  PropsWithChildren,
  ReactNode,
} from "react";

function SelectField({
  initialValue,
  label,
  name,
  id,
  labelStyle,
  labelClassName,
  inputStyle,
  inputClassName,
  onChange,
  options,
}: PropsWithChildren<{
  initialValue?: string;
  label?: ReactNode | string;
  name?: string;
  id?: string;
  labelClassName?: string;
  inputClassName?: string;
  labelStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  onChange: ChangeEventHandler<HTMLSelectElement> | undefined;
  options?: { value: any; label?: any }[];
}>) {
  return (
    <div>
      <div style={{ ...labelStyle }} className={labelClassName}>
        <label htmlFor={id}>
          <span>{label}</span>
        </label>
      </div>
      <select
        onChange={onChange}
        id={id}
        defaultValue={initialValue}
        name={name}
        style={inputStyle}
        className={inputClassName}
      >
        {options?.map((option, id) => (
          <option
            value={option.value}
            key={`${option.value}`}
            selected={initialValue == option.value}
          >
            {option.label || String(option.value)}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectField;
